import { setEqualHeight } from './equalHeight.js';
setEqualHeight( '.e-stn--stats-cards', '.e-ctr__d' );